import EnterOtpComponent from './EnterOtpContainer';

export default EnterOtpComponent;